import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Relocation from "@/pages/Relocation";
import Projects from "@/pages/Projects";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Consultation from "@/pages/Consultation";
import Team from "@/pages/Team";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-white text-[#000000]">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/relocation" element={<Relocation />} />
            <Route path="/operations-analytics" element={<Navigate to="/relocation" replace />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/meet-the-team" element={<Navigate to="/team" replace />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/free-consultation" element={<Navigate to="/consultation" replace />} />

            {/* Backward-compat redirects */}
            <Route path="/services" element={<Navigate to="/" replace />} />
            <Route path="/services/relocation-consulting" element={<Navigate to="/relocation" replace />} />
            <Route path="/services/logistics-workflow-consulting" element={<Navigate to="/relocation" replace />} />
            <Route path="/services/it-automation-consulting" element={<Navigate to="/relocation" replace />} />
            <Route path="/relocation-consulting" element={<Navigate to="/relocation" replace />} />
            <Route path="/logistics-workflow-consulting" element={<Navigate to="/relocation" replace />} />
            <Route path="/it-automation-consulting" element={<Navigate to="/relocation" replace />} />
            <Route path="/insights" element={<Navigate to="/" replace />} />
            <Route path="/industries" element={<Navigate to="/" replace />} />

            <Route path="*" element={<Home />} />
          </Routes>
        </div>
        <Footer />
        <Toaster position="bottom-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
